<div class="page">
    <div class="container-fluid">
        <div class="row page-header">
            <div class="col-md-8">
                <h3>Internal Assessment - {{subject.topic}} <br>
                    <small>{{batch.course.name}} - Batch {{batch.start_year}}</small> &nbsp;
                    <small>Year: {{batch.current_semester}}</small>
                </h3>
            </div>

            <div class="col-md-4 text-right">
                <button class="btn btn-primary" (click)="openConfigModal()">
                    <i class="fa fa-cog"></i> Configure Components
                </button>
            </div>
        </div>

        <div class="page-body">
            <!-- Loading -->
            <div *ngIf="loading" class="text-center p-4">
                <i class="fa fa-spinner fa-spin fa-2x"></i>
                <p>Loading...</p>
            </div>

            <!-- No Configuration -->
            <div *ngIf="!loading && iaConfig.length == 0" class="alert alert-warning">
                <strong>No components configured!</strong> Please configure assessment components first.
                <button class="btn btn-sm btn-primary ml-3" (click)="openConfigModal()">Configure Now</button>
            </div>

            <!-- Marks Entry Table -->
            <div *ngIf="!loading && iaConfig.length > 0" class="marks-table-container">
                <div class="table-responsive">
                    <table class="table table-bordered table-sm marks-table">
                        <thead>
                            <tr>
                                <th class="sticky-col first-col">Student ID</th>
                                <th class="sticky-col second-col">Student Name</th>
                                <ng-container *ngFor="let comp of iaConfig">
                                    <th *ngFor="let attempt of getAttemptArray(comp.number_of_attempts)" class="text-center attempt-col">{{comp.component_name}}<br>Attempt {{attempt}}</th>
                                    <th class="text-center avg-col">{{comp.component_name}}<br>Avg</th>
                                    <th class="text-center scaled-col">{{comp.component_name}}<br>Scaled</th>
                                </ng-container>
                                <th class="final-col">Final Total</th>
                            </tr>
                        </thead>

                        <tbody>
                            <ng-container *ngIf="data.list.length > 0; else noData">
                                <tr *ngFor="let student of data.list">
                                    <td class="sticky-col first-col">{{student.student_id}}</td>
                                    <td class="sticky-col second-col">{{student.name}}</td>
                                    <ng-container *ngFor="let comp of iaConfig">
                                        <td *ngFor="let attempt of getAttemptArray(comp.number_of_attempts)" class="attempt-input">
                                            <input type="number" class="form-control form-control-sm score-input" [class.saving]="savingScores[student.id + '-' + comp.id + '-' + attempt]" [value]="iaScores[student.id] && iaScores[student.id][comp.id] && iaScores[student.id][comp.id].attempts[attempt]" (change)="onScoreChange(student.id, comp.id, attempt, $event.target.value)" [max]="comp.base_marks" step="0.01" placeholder="-" />
                                        </td>
                                        <td class="avg-col text-center">{{iaScores[student.id] && iaScores[student.id][comp.id] && iaScores[student.id][comp.id].avg | number:'1.2-2'}}</td>
                                        <td class="scaled-col text-center">{{iaScores[student.id] && iaScores[student.id][comp.id] && iaScores[student.id][comp.id].scaled | number:'1.2-2'}}</td>
                                    </ng-container>
                                    <td class="final-col text-center font-weight-bold">{{student.ia_total || '0.00'}}</td>
                                </tr>
                            </ng-container>
                            
                            <ng-template #noData>
                                <tr>
                                    <td [attr.colspan]="getTotalColspan()" class="text-center">
                                        No students found!
                                    </td> 
                                </tr>
                            </ng-template>
                        </tbody>
                    </table>
                </div>
            </div>

            <!-- Pagination -->
            <div class="row" style="margin-bottom: 30px; margin-top: 20px;" *ngIf="!loading && data.list.length > 0">
                <div class="col-md-6">
                    <img src="assets/img/icon-arrow-left-active.svg" class="btn btn-nav" *ngIf="offset > 0" (click)="paginate(1)" />
                </div>
                <div class="col-md-6 text-right">
                    <img src="assets/img/icon-arrow-right-active.svg" class="btn btn-nav" *ngIf="data.count > offset+limit" (click)="paginate(2)" />
                </div>
            </div>

        </div>

    </div>
</div>

<!-- Configuration Modal -->
<app-internal-assessment-config 
    [subjectId]="subjectId" 
    [subjectName]="subject.topic"
    (configSaved)="onConfigSaved()">
</app-internal-assessment-config>

